import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'

class ForOwnerSideNavBar extends React.Component {
  state = {
    categoryList: [],
  }

  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            categoryList: res.data.data,
          })
        }
      })
  }

  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="feather icon-home"></i>
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>
            <li className=" ">
              <Link to="/booking">
                <span className="pcoded-micon edit">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">Bookings</span>
              </Link>
            </li>
            <li className="">
              <Link to="/boat-Captain">
                <span className="pcoded-micon">
                  <i className="icofont icofont-police"></i>
                </span>
                <span className="pcoded-mtext">Boat Captain</span>
              </Link>
            </li>
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Boat Master</span>
              </a>
              <ul className="pcoded-submenu">
                {this.state.categoryList?.map(
                  (itm) =>
                    itm.is_active &&
                    itm.category_type == 'CRUISE' && (
                      <li
                        className=" "
                        key={itm.id}
                      >
                        <Link to={`/boatsmaster/${itm.cruise_cat_en}/${itm.id}`}>
                          <span className="pcoded-mtext">{itm.cruise_cat_en}</span>
                        </Link>
                      </li>
                    )
                )}
              </ul>
            </li>
            <li className="">
              <Link to="/events">
                <span className="pcoded-micon">
                  <i className="icofont icofont-life-buoy"></i>
                </span>
                <span className="pcoded-mtext">Event</span>
              </Link>
            </li>
            <li className="">
              <Link to="/custominquiry">
                <span className="pcoded-micon">
                  <i className="icofont icofont-question"></i>
                </span>
                <span className="pcoded-mtext">Custom Inquiry</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForOwnerSideNavBar
